import { ComputedRef } from 'vue'

import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { PostArenaSubmissionViewModel } from '@/presentation/viewmodels/arena/postArenaSubmissionViewModel'

export class PostArenaSubmissionPresenter {
  private viewModel: PostArenaSubmissionViewModel

  constructor(viewModel: PostArenaSubmissionViewModel) {
    this.viewModel = viewModel
  }

  get judgeToken(): ComputedRef<string> {
    return this.viewModel.judgeToken
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async postArenaSubmission(
    problemId: string,
    arenaProblemId: string,
    arenaId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string
  ): Promise<void> {
    await this.viewModel.postArenaSubmission(problemId, arenaProblemId, arenaId, programLanguage, sourceCode)
  }
}
